// extracted by mini-css-extract-plugin
export default {"logo__container":"Logo_logo__container__uqv6K"};